import React from "react";
import { fmtET } from "@/lib/time";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const TimestampET = ({ value, format = "full" }) => {
    if (!value) return <span className="text-muted-foreground">—</span>;
    const et = fmtET(value, { dateOnly: format === "date", timeOnly: format === "time" });
    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="font-mono tabular-nums text-xs text-muted-foreground whitespace-nowrap">
                        {et}
                    </span>
                </TooltipTrigger>
                <TooltipContent side="top" className="font-mono text-xs">
                    <div>UTC: {String(value)}</div>
                    <div>ET : {et}</div>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
